import { ISagaModule } from "redux-dynamic-modules-saga";
import { AccountSettings, accountSettingsReducer } from "./reducers/accountSettings";
import { accountSettingsRootSaga } from "./sagas";

export interface AsState {
    accountSettings: AccountSettings;
}

export const getAccountSettingsModule = (): ISagaModule<AsState> => ({
    id: "accountSettings",
    reducerMap: {
        accountSettings: accountSettingsReducer,
    },
    sagas: [accountSettingsRootSaga],
});
